export default function (itemName, data) {
  if (!data) return '';

  if (data.approveStatus) {
    // New Approval Object

    let displayStatus = [],
      popoverHtml = '';
    for (let status in data.approveStatus) {
      let text = `${data.approveStatus[status].title} <b>${data.approveStatus[status].count}</b>`;
      if (status === 'Approved')
        displayStatus.push(
          `<span class="status-label text-success" data-aid="status-success"><i class="far fa-fw fa-file-signature"></i> ${text}</span>`
        );
      else if (status === 'Disapproved')
        displayStatus.push(
          `<span class="status-label text-danger" data-aid="status-danger"><i class="far fa-fw fa-file-times"></i> ${text}</span>`
        );
      else
        displayStatus.push(
          `<span class="status-label text-muted" data-aid="status-muted"><i class="far fa-fw fa-file-signature"></i> ${text}</span>`
        );
    }

    let popoverDataArr = [];
    for (let status in data.approveDisplayData) {
      data.approveDisplayData[status].forEach((data) => {
        let title =
          status === 'Approved'
            ? `<span class='ml-n3 status-label text-success'><i class='far fa-fw fa-file-signature'></i> ${data.title}</span>`
            : status === 'Disapproved'
            ? `<span class='ml-n3 status-label text-danger'><i class='far fa-fw fa-file-times'></i> ${data.title}</span>`
            : `<span class='ml-n3 status-label text-muted'><i class='far fa-fw fa-file-signature'></i> ${data.title}</span>`;
        popoverDataArr.push(`<div class='d-flex flex-column mb-2'>
        ${title}
        <div class="pl-3">
          <p class="my-1">${data.created}</p>
          ${
            data.comments ? `<div class='d-flex'><b class="mr-2">Comments:</b> <span>${data.comments}</span></div>` : ``
          }
        </div>
      </div>`);
      });
    }
    if (popoverDataArr.length) {
      let content = `<div class='d-flex flex-column pl-2'>${popoverDataArr.join('')}</div>`;
      popoverHtml = `<a href="javascript:" 
                      data-content="${content.replaceAll('"', '&quot;')}" 
                      data-html="true" 
                      data-trigger="hover" 
                      data-toggle="popover" class="ml-1"><i class="fal fa-info-circle fa-lg"></i></a>`;
    }

    return `<span class="d-inline-flex">${displayStatus.join(' ')} ${popoverHtml}</span>`;
  } else {
    let approved = data.approved * 1;
    let popover = data.comments
      ? ' title="Reason" data-content="' +
        data.comments.replaceAll('"', '&quot;') +
        '" data-trigger="hover" data-toggle="popover" '
      : '';
    let statusColor, statusIcon, statusText;
    switch (approved) {
      case 1:
        statusColor = 'success';
        statusIcon = 'file-signature';
        statusText = $Lang.common.Approved;
        break;
      case 2:
        statusColor = 'danger';
        statusIcon = 'file-times';
        statusText = $Lang.common.Rejected;
        break;
      case 3:
        statusColor = 'warning';
        statusIcon = 'file-signature';
        statusText = $Lang.common.PartialApproved;
        break;
      case 4:
        statusColor = 'warning';
        statusIcon = 'file-times';
        statusText = $Lang.common.PartialRejected;
        break;
      default:
        statusColor = 'muted';
        statusIcon = 'file-signature';
        statusText = $Lang.common.Unspecified;
    }
    let aid = `${itemName}-${statusText.toLowerCase()}`;
    if (itemName == 'mockup' && approved === 0) {
      statusText = `Approval ${statusText}`;
    }
    if (!statusColor) return '';
    return `<span ${popover} class="status-label text-${statusColor}" data-aid="${aid}"><i class="far fa-fw fa-${statusIcon} mr-1"></i>${statusText}</span>`;
  }
}
